//
// The Old Rusty: dont use this. Use the new shiney in utils.js
//


/**
 * Dialog Object: This object creates and manipulates the DOM for roles in the View.
 * It is currently in use for admin/hierarchy.
 * NOTE: all ids should be just the specific purpose of the dialog. Prefix and type will be appended in this object.
 */
dialogDefaults = function() {
	'use strict';

	return {
		modal: true,
		dialogClass: 'curriculog-dialog',
		resizable: false,
		draggable: true,
		'width': 600,
		buttons: '',
		close: '',
		help: dialogHelp
	};
};

dialogHelp = function() {
	'use strict';

	$('.ui-dialog-titlebar').append('<div class="dialog-help"><button class="dialog-help-button" name="show-help-text" title="Show Help Text"></button></div>');

	// Bind click event
	$('.ui-dialog').on('click', '.dialog-help-button', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('.ui-widget-overlay').css('position', 'fixed');
		$(this).closest('.ui-dialog').find('.help').slideToggle(200);
	});

	// Unbind click event whenever a dialog is closed
	$('.ui-dialog').bind('dialogclose', function(event) {
		$('.ui-dialog').off('click', '.dialog-help-button');
		$(this).find('.help').hide();
		$('.ui-widget-overlay').css('position', 'absolute');
	});
};

dialog = function() {
	'use strict';

	var objDialog = {};
	var defaults = {
		modal: true,
		dialogClass: 'curriculog-dialog',
		resizable: true,
		draggable: false,
		'width': 600,
		buttons: '',
		close: '',
		help: dialogHelp
	};

	objDialog.createBasicDialog = function(id, title, callback) {
		var dialogTitle = (title.length > 0) ? title : '';
		var dialog = $('<div></div>');
		$(dialog).attr('id', 'curriculog-dialog' + id).attr('title', dialogTitle);
		defaults = dialogDefaults();

		objDialog.initBindings(dialog);

		if (callback) {
			callback(dialog, defaults);
		}
    objDialog.postInitBindings(dialog);
	};

	objDialog.createBasicNotification = function(id, message, callback) {
		var dialog = $('<div></div>');
		$(dialog).attr('id', 'curriculog-dialog' + id).attr('title', message);
		var defaults = dialogDefaults();
		defaults.dialogClass = 'curriculog-dialog message';
		defaults.minHeight = 30;

		objDialog.initBindings(dialog);

		if (callback) {
			callback(dialog, defaults);
		}
    objDialog.postInitBindings(dialog);
	};

	objDialog.createBasicWarningDialog = function(id, callback) {
		var dialog = $('<div></div>');
		$(dialog).attr('id', 'curriculog-dialog-' + id + '-warning').attr('title', 'Warning');
		var defaults = dialogDefaults();
		defaults.dialogClass = 'curriculog-dialog warning';

		objDialog.initBindings(dialog);


		if (callback) {
			callback(dialog, defaults);
		}
    objDialog.postInitBindings(dialog);
	};

	objDialog.createDOMDialog = function(id, callback) {
		var dialog = $('#' + id).addClass('active').attr('tabindex',0);
		var defaults = dialogDefaults();

		objDialog.initBindings(dialog);

		if (callback) {
			callback(dialog, defaults);
		}
	};

	objDialog.createDOMWarningDialog = function(id, callback) {
		var dialog = $('#' + id).addClass('active');
		var defaults = dialogDefaults();
		defaults.dialogClass = 'curriculog-dialog warning';

		objDialog.initBindings(dialog);

		if (callback) {
			callback(dialog, defaults);
		}
	};

	objDialog.initBindings = function(dialog) {
		if ($('.ui-widget-overlay').length === 0) {
			$(dialog).bind('dialogopen', function() {
        $('body').addClass('dialog-opened');
			});

			$(dialog).bind('dialogclose', function(event, ui) {
        $('body').removeClass('dialog-opened');
			});
		}

	};
  // done to have the event binding after the user defined init
  objDialog.postInitBindings = function(dialog) {
    // Reset to pre-init state on close
    $(dialog).bind('dialogclose', function(event, ui) {
      var target = $(event.target);
      // check if dialog has been initialized before closing it
      if (target.data('ui-dialog')) {
        target.dialog('destroy');
      }

    });
  };

	return objDialog;
};

/*
 * EXAMPLE OF BASIC DIALOG CODE
		var dialog = objDialog.createBasicWarningDialog('remove-parent', function(dialog, defaults) {
			// Message
			escapedParentName = escapeUserInput($(obj).closest('li').text());
			escapedChildName = escapeUserInput($('#entity-details-name').val());

			$(dialog).append('Are you sure you want to remove <span class="strong">'+ escapedParentName + '</span>');
			$(dialog).append(' as a parent of ' + escapedChildName + '?');
			// Actions
			defaults.buttons = {
				'Delete Parent': function() {
					// STUFF
					$(this).dialog('close');
				},
				Cancel: function() {
					// STUFF
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				// STUFF
			};
			$(dialog).dialog(defaults);

		});
 *
 * EXAMPLE OF BASIC DOM DIALOG CODE
		var dialog = objDialog.createDOMWarningDialog('entity-reparent-dialog', function(dialog, defaults) {
			// Message
			// DOM CHANGING STUFF

			// Actions
			defaults.buttons = {
				'Reparent children and Delete Entity': function() {
					// STUFF
					$(this).dialog('close');
				},
				Cancel: function() {
					// STUFF
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				// STUFF
			};
			$(dialog).dialog(defaults);

		});
 * */
